import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/stripe-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-2fac0bf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner-overlay" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Billing Information", -1))
const _hoisted_3 = { class: "checkout" }
const _hoisted_4 = { class: "stripe-payment" }
const _hoisted_5 = { class: "stripe-footer" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stripe-credit" }, [
  /*#__PURE__*/_createTextVNode(" Powered by "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StripeElement = _resolveComponent("StripeElement")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.license.title) + " License - $" + _toDisplayString(_ctx.license.price.toLocaleString()), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_StripeElement, {
        element: _ctx.cardElement,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleChange($event)))
      }, null, 8, ["element"]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("button", {
          class: "stripe-submit",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.registerCard && _ctx.registerCard(...args)))
        }, "Checkout")
      ])
    ])
  ]))
}